import React, { useState } from 'react';
import { motion } from "framer-motion";
export default function StripBookingBar(props) {
    var _a = useState(0), countAdults = _a[0], setCountAdults = _a[1];
    var _b = useState(0), countYouth = _b[0], setCountYouth = _b[1];
    var _c = useState(0), totalPersons = _c[0], setTotalPersons = _c[1];
    function incrementCountAdults() {
        countAdults = countAdults + 1;
        totalPersons = totalPersons + 1;
        setCountAdults(countAdults);
        setTotalPersons(totalPersons);
    }
    function decrementCountAdults() {
        countAdults = countAdults - 1;
        totalPersons = totalPersons - 1;
        setCountAdults(countAdults);
        setTotalPersons(totalPersons);
    }
    function incrementCountYouth() {
        countYouth = countYouth + 1;
        totalPersons = totalPersons + 1;
        setCountYouth(countYouth);
        setTotalPersons(totalPersons);
    }
    function decrementCountYouth() {
        countYouth = countYouth - 1;
        totalPersons = totalPersons - 1;
        setCountYouth(countYouth);
        setTotalPersons(totalPersons);
    }
    return (React.createElement(motion.div, { initial: { opacity: 1 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip sky23-booking-bar container-fluid strip-spacing position-relative" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "persons-adults" },
                React.createElement("div", { className: "adults-description d-flex flex-row" },
                    React.createElement("div", { className: "adults" }, "Adults"),
                    React.createElement("div", { className: "after-14" }, "After 14"),
                    React.createElement("button", { onClick: decrementCountAdults, disabled: countAdults == 0 ? true : false }, "-"),
                    React.createElement("div", { className: "count" }, countAdults),
                    React.createElement("button", { onClick: incrementCountAdults }, "+"))),
            React.createElement("div", { className: "persons-youth" },
                React.createElement("div", { className: "youth-description d-flex flex-row" },
                    React.createElement("span", { className: "adults" }, "Youth"),
                    React.createElement("span", { className: "after-14" }, "12-14 years"),
                    React.createElement("button", { onClick: decrementCountYouth, disabled: countYouth == 0 ? true : false }, "-"),
                    React.createElement("div", { className: "count" }, countYouth),
                    React.createElement("button", { onClick: incrementCountYouth }, "+")))),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "booking-details d-flex flex-row" },
                React.createElement("div", { className: "booking-calendar" }, "Calendar"),
                React.createElement("div", { className: "icon-person" }, "Icon"),
                totalPersons > 0 &&
                    React.createElement("div", { className: "total-persons" },
                        React.createElement("span", { className: "count" }, totalPersons),
                        totalPersons == 1 && React.createElement("span", { className: "persons" }, "Person"),
                        totalPersons > 1 && React.createElement("span", { className: "persons" }, "Persons")),
                React.createElement("div", null,
                    React.createElement("button", { className: "book-now" }, "Book Now"))))));
}
